import moment from 'jalali-moment';
import React,{useEffect,useState,useContext} from 'react'
import { DateInput } from "react-hichestan-datetimepicker";
import { AuthContextUser } from "../context/UserContext";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";

export const NobatOnlineAssistant = () => {

    const { currentUser } = useContext(AuthContextUser);

    const [tm1,setTm1] = useState(0)
    const [tm2,setTm2] = useState(0)
    const [tm3,setTm3] = useState('')
    const [tadad,setTadad] = useState('')
    const [dateRF1, setdateRF1] = useState(new Date());
    const [day,setDay] = useState('')

const handleChangeR = (event) => {
 try {
    setdateRF1(
        moment(new Date(event.target.value), "YYYY/MM/DD")
        .locale("fa")
        .format("YYYY/MM/DD")
    );
  } catch (err) {}
};

const [kol,setKol] = useState([])
const [token,settokenID] = useState('')

useEffect(() => {
  settokenID(Math.floor(Math.random() * 23580120) + 18);
}, []);

const handelSubmit = async() => {
try{
    setKol([])
    var s1 = parseInt(tm1)
    var s2 = parseInt(tm2)
    let c = parseInt(tm3)
    for(s1; s1<=s2;s1++){
    for (var i = 0; i <= 60; i += c)
    {
      if(i < 60) {
         var db = s1 +':' + i;
         kol.push({nezam:currentUser.nezam,db:db,tadad:tadad,dateRF1:dateRF1.replace("/","-").replace("/","-"),token:token,day:day})
       }
    }
  }
      settokenID(Math.floor(Math.random() * 23580120) + 18);
      await axios.post('https://clinic.salamatpayanew.ir/admin/timeFarm', kol)
      toast.success('نوبت های آنلاین ایجاد شد')
    }catch(err){
      toast.warning('لطفا تاریخ را انتخاب نمائید')
    }
}


if (currentUser.meli === null) {
} else {
return (
 <>
<section class="m-0 content" dir='rtl'>
 <div class="d-flex flex-column justify-content-start align-items-center">
    <div class="card">
        <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
        <div class="d-flex flex-column justify-content-start card-title-container">
            <div class="card-title text-secondary">ثبت سرویس</div>
        </div>
    <br />
    <p></p>
        <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-8">
            <div class="custom-form-control form-group position-relative w-50">
                <input type="text" class="form-control pr-16 my-2" placeholder="از ساعت" onChange={e=>setTm1(e.target.value)} />
            </div>
            <div class="custom-form-control form-group position-relative w-50">
                <input type="text" class="form-control pr-16 my-2" placeholder="تا ساعت" onChange={(e=>setTm2(e.target.value))} />
            </div>
            <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                <input type="text"  class="form-control pr-16 my-2" placeholder="مدت زمان" onChange={(e=>setTm3(e.target.value))}/>
            </div>
            <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
                <input type="text" maxLength={2} class="form-control pr-16 my-2" placeholder="تعداد ویزیت" onChange={(e=>setTadad(e.target.value))} />
            </div>
            </div>
            <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-8">
            <div class="custom-form-control form-group position-relative w-50 m-0 mx-md-3">
              <select className='form-control' onChange={(e=>setDay(e.target.value))}>
                  <option value={'روز'}>انتخاب روز</option>
                  <option value={'شنبه'}>شنبه</option>
                  <option value={'یکشنبه'}>یکشنبه</option>
                  <option value={'دوشنبه'}>دوشنبه</option>
                  <option value={'سه شنبه'}>سه شنبه</option>
                  <option value={'چهارشنبه'}>چهارشنبه</option>
                  <option value={'پنج شنبه'}>پنج شنبه</option>
              </select>
            </div>
            <div class="custom-form-control form-group position-relative w-50 m-0 me-md-3">
                    <DateInput
                            value={dateRF1}
                            name={"dateRF1"}
                            onChange={handleChangeR}
                            className="form-control"
                    />
            </div>
        </div>
        <p></p>
        <button className='btn btn-danger col-sm-3' onClick={handelSubmit}>تایید نوبت آنلاین</button>
    </div>
</div>
</section>
<ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      </>
    )
  }
}
